import stepBuilderUtils from "../utils/customsteps";

const processStepsGeneric = (steps, chatFormIdentifier, type, identifier, identifierType) => {
    let processedSteps =[];
    for(let i=0; i < steps.length; i++){
        if (
            (steps[i]['id'].indexOf('option') >= 0) ||
            (steps[i]['id'].indexOf('input') >= 0) ||
            (steps[i]['id'].indexOf('upload') >= 0) ||
            (steps[i]['id'].indexOf('multi') >= 0) ||
            (steps[i]['id'].indexOf('call') >= 0)
        ){
            // extract identifier from step id name
            // so each branch will have its own next step, so there would be api call step for each branch
            let stepIdentifier;
            let currStep = steps[i];
            let stepName;
            let nextStepName;

            if (steps[i]['id'].indexOf('option') >= 0) {
                let apiCallStep;
                let options = currStep['options'];
                for(let j=0; j<options.length; j++){
                    let attach = Math.random().toString(36).substr(2, 8);
                    // attachments.push(attach);
                    currStep['options'][j]['trigger'] = attach + currStep['options'][j]['trigger'];
                }
                processedSteps.push(steps[i]);
                stepIdentifier = steps[i]['id'].substring(6);
                options = currStep['options'];
                for(let j=0; j<options.length; j++){
                    stepName = options[j]['trigger'];
                    nextStepName = options[j]['trigger'].substring(8);
                    apiCallStep = stepBuilderUtils.submitApiCall(stepName, stepIdentifier, nextStepName, 'option', chatFormIdentifier, type, identifier, identifierType);
                    processedSteps.push(apiCallStep);
                }
            }
            else if((steps[i]['id'].indexOf('input') >= 0)){
                let apiCallStep;
                stepIdentifier = steps[i]['id'].substring(5); //correct
                if (steps[i]['validation'] === true) {
                    if (steps[i]['validation_type'] === 'mobile_no') {
                        steps[i] = stepBuilderUtils.attachMobileNoValidator(steps[i]);
                    }
                    else if (steps[i]['validation_type'].indexOf("document_") >= 0){ 
                        steps[i] = stepBuilderUtils.attachDocumentValidator(steps[i]);
                    }
                    else if (steps[i]['validation_type'] === 'alpha_num') {
                        steps[i] = stepBuilderUtils.attachAlphaNumValidator(steps[i]);
                    }
                    delete steps[i]['validation'];
                    delete steps[i]['validation_type']
                }
                let attach = Math.random().toString(36).substr(2, 8);
                stepName = attach + currStep['id'];
                nextStepName = currStep['trigger'];
                currStep['trigger'] = stepName;
                processedSteps.push(steps[i]);
                apiCallStep = stepBuilderUtils.submitApiCall(stepName, stepIdentifier, nextStepName, 'text', chatFormIdentifier, type, identifier, identifierType);
                processedSteps.push(apiCallStep);
            }
            else if((steps[i]['id'].indexOf('upload') >= 0)){
                let fileUploadStep;
                stepIdentifier = steps[i]['id'].substring(6); //correct
                // let attach = Math.random().toString(36).substr(2, 8);
                stepName = currStep['id'];
                nextStepName = currStep['trigger'];
                currStep['trigger'] = stepName;
                fileUploadStep = stepBuilderUtils.handleFileUpload(stepName, stepIdentifier, nextStepName, chatFormIdentifier, type, identifier, identifierType);
                processedSteps.push(fileUploadStep);
            }
            else if((steps[i]['id'].indexOf('call') >= 0)){
                let callButton;
                stepIdentifier = steps[i]['id'].substring(4); //correct
                stepName = currStep['id'];
                let isEnd = currStep['end']
                nextStepName = isEnd ? null : currStep['trigger'];
                let phoneNumber = currStep['phone']
                callButton = stepBuilderUtils.callButtonComponent(stepName, stepIdentifier, nextStepName, chatFormIdentifier, type, identifier, identifierType, phoneNumber, isEnd)
                processedSteps.push(callButton);
            } else if (steps[i]['id'].indexOf('multi') >= 0) {
                let apiCallStep;
                let choices = currStep['choices'];
                let attach = Math.random().toString(36).substring(2, 10);
                currStep['trigger'] = attach + currStep['trigger'];

                processedSteps.push(steps[i]);

                stepIdentifier = steps[i]['id'].substring(5);
                choices = currStep['choices'];
                nextStepName = currStep['trigger']
                for(let j=0; j<choices.length; j++){
                    stepName = currStep['trigger'];
                    nextStepName = currStep['trigger'].substring(8);
                    apiCallStep = stepBuilderUtils.submitApiCall(stepName, stepIdentifier, nextStepName, 'multi', chatFormIdentifier, type, identifier, identifierType);
                    processedSteps.push(apiCallStep);
                }
            }
        }
        else{
            processedSteps.push(steps[i]);
        }
    }
    return processedSteps;
};

const processStepsFileUploadEnableFields = (steps, chatFormIdentifier, type, identifier, identifierType, enable_fields) => {
    let modifiedSteps =[];

    for(let i=0; i < steps.length; i++){
        let name = steps[i]['id']
        let modifiedName = null
        if (name.indexOf('message') === 0) {
            modifiedName = name.slice('message'.length, name.length)
        }
        else if (name.indexOf('option') === 0) {
            modifiedName = name.slice('option'.length, name.length)
        }
        else if (name.indexOf('input') === 0) {
            modifiedName = name.slice('input'.length, name.length)
        }
        else if (name.indexOf('upload') === 0) {
            modifiedName = name.slice('upload'.length, name.length)
        }
        if (enable_fields.indexOf(modifiedName) >= 0 || steps[i]['enabled']) {
            modifiedSteps.push(steps[i])
        }
    }

    modifiedSteps.push({
        'id': 'thanksStep',
        'end': true,
        'message': 'Thanks for your information'
    }
    );

    for(let i=0;i< modifiedSteps.length-1; i++){
        modifiedSteps[i]['trigger'] = modifiedSteps[i+1]['id']
        try {
            delete steps[i]['enabled'];
        }
        catch (e) {}
    }
    return processStepsGeneric(modifiedSteps, chatFormIdentifier, type, identifier, identifierType);
};

const processStepsFullyAutomatedOnboarding = (steps, chatFormIdentifier, type, identifier, identifierType, candidateName, mobileNo, city, location) => {
    let modifiedSteps =[];
    for(let i=0; i < steps.length; i++){
        if (steps[i]['custom_component'] === true) {
            let currStep = steps[i];
            let stepIdentifier = steps[i]['id'].substring(6)
            let stepName = currStep['id'];
            let nextStepName = currStep['trigger'];
            let customComponentType = currStep['custom_component_type']
            if (customComponentType === 'uber_upload_component') {
                modifiedSteps.push(stepBuilderUtils.uberConfirmDetailComponent(stepName,
                    stepIdentifier,
                    nextStepName,
                    chatFormIdentifier,
                    type,
                    identifier,
                    identifierType,
                    candidateName,
                    mobileNo,
                    city
                ))
            }
            else if (customComponentType === 'sfx_upload_component'){
                modifiedSteps.push(stepBuilderUtils.sfxConfirmDetailComponent(
                    stepName,
                    stepIdentifier,
                    nextStepName,
                    chatFormIdentifier,
                    type,
                    identifier,
                    identifierType,
                    candidateName,
                    mobileNo,
                    city,
                    location
                ))
            }
            else if (customComponentType === 'dunzo_upload_component'){
                modifiedSteps.push(stepBuilderUtils.dunzoConfirmDetailComponent(
                    stepName,
                    stepIdentifier,
                    nextStepName,
                    chatFormIdentifier,
                    type,
                    identifier,
                    identifierType,
                    candidateName,
                    mobileNo,
                    city,
                    location
                ))
            }
            else if (customComponentType === 'sfx_app_link_component'){
                modifiedSteps.push(stepBuilderUtils.sfxAppLinkComponent(stepName, chatFormIdentifier))
            }
            else if (customComponentType === 'dunzo_app_link_component'){
                modifiedSteps.push(stepBuilderUtils.dunzoAppLinkComponent(stepName))
            }
        }
        else {
            modifiedSteps.push(steps[i]);
        }
    }
    return processStepsGeneric(modifiedSteps, chatFormIdentifier, type, identifier, identifierType);
}


export default {processStepsGeneric, processStepsFileUploadEnableFields, processStepsFullyAutomatedOnboarding} ;


